const locale = {
    placeholder: 'Избор на час',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/bg_BG.tsx